import { Tab, Tabs } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import { useRoutePropsUi, useRouteStore } from "components/utils/RouteUtils"
import React from "react"
import { useLocation } from "react-router"

export const RouteTab = React.memo(({ value, onChange, label, ...props }) => {
	const routePropsUi = useRoutePropsUi()
	// MTVW-745: disableFocusRipple
	//console.debug("RouteTab", value, onChange, props)

	//MTVW-1078: replaced for label with textOverflow/ellipsis
	//return <Tab disableFocusRipple={true} {...props} {...routePropsUi(value)} />

	const routeProps = React.useMemo(() => routePropsUi(value), [routePropsUi, value])

	return <Tab
		disableFocusRipple={true} {...props} {...routeProps}
		label={
			<span style={{
				display: "inline-block",
				// French 'ENREGISTREMENTS' maxWidth: 160 -> "unset"
				maxWidth: props.icon ? "calc(98vw / 5)" : "unset",
				overflow: "hidden",
				whiteSpace: "nowrap",
				textOverflow: "ellipsis",
			}}>
				{label}
			</span>
		}
	/>
})

export const RouteTabs = CreateComponent(null, false, true, ({ routeCustomName, ...props }) => {
	const routeStore = useRouteStore()
	const routeMatch = useLocation()
	const value = routeStore.getVar(routeMatch.pathname, routeCustomName, routeMatch.name)
	//console.debug("value=", value, routeMatch.name)
	// MTVW-918: standard onChange returns newValue as undefined
	// Fix: moved out of render to avoid infinite update loop
	React.useEffect(() => {
		if (value && props.onChange) props.onChange(null, value)
	}, [value]) // eslint-disable-line react-hooks/exhaustive-deps
	// MTVW-1061: stopPropagation
	return (
		<Tabs
			{...props}
			value={value}
			onClick={(e) => {
				e.stopPropagation()
				props.onClick?.(e)
			}}
			onTouchStart={(e) => {
				e.stopPropagation()
				props.onTouchStart?.(e)
			}}
		/>
	)
})
